export const EVENTS = {
    CLICK: 'click',
    CHANGE: 'change',
    SCROLL: 'scroll',
};

export const ATTRIBUTES = {
    ACTIVE_TAB: 'active-tab',
    USE_HISTORY: 'use-history',
};
